export default {
  // 函数名称和key值保持一致
  userInfo: state => state.userInfo,
};



// WEBPACK FOOTER //
// ./src/store/home/getters.js